import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Rfq } from 'src/shared/types/rfq';

import { updateRfqStep, UpdateRfqStepPayload } from '../api/updateRfqStep';

const useUpdateRfqStep = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateRfqStepPayload) => updateRfqStep(payload),
    onSuccess: (data) => {
      queryClient.setQueryData<Rfq>(['rfq', String(data.rfq.id)], data);
    }
  });
};

export default useUpdateRfqStep;
